import $ from 'jquery';
import Swiper, { Navigation, Pagination } from 'swiper';
import niceScroll from "jquery.nicescroll"
import Scripts from './modules/scripts.js';

Swiper.use([Navigation, Pagination]);
new Scripts();


$(document).ready(function () {
  $('#periode1, #periode2, #periode3, #periode4').on('scroll', function () {
    if($(this).getNiceScroll(0) === false) {
      return
    }

    if ($(this).getNiceScroll(0).getScrollTop() > 0) {
      $('.menu-show2').addClass('return');
      $('.menu-show1').removeClass('begin');
    }
    else {
      $('.menu-show2').removeClass('return');
      $('.menu-show1').addClass('begin');
    }

    $(this).getNiceScroll().resize();
  })

  $('.menu-show').on('click', function () {
    if ($('.pt-page-current').getNiceScroll(0).getScrollTop() > 0) {
      $('.pt-page-current').getNiceScroll(0).doScrollTop(0, 5000);
    }
    else {
      var scrollPos = $('.periode-global').offset().top;
      $('.pt-page-current').getNiceScroll(0).doScrollTop(scrollPos, 5000);
    }
  })
  
  
})




// $ui.trigger.on('click', _onLoadMore);
$(document).on('click', '.js-switch-page', function (e) {

  _switchPage(e);
})

function _switchPage(evt) {
  // evt.preventDefault();


  let isAnimating = true;

  var nextPage = $(evt.target).data('page')
  if (nextPage === '#periodes') {
    setTimeout(function () {
      $(nextPage + ".pt-page-current .intro-content").addClass("load-animate-3");
    }, 1000)
  }
  if (nextPage === '#periode1' || nextPage === '#periode2' || nextPage === '#periode3' || nextPage === '#periode4') {

    setTimeout(function () {
      $(nextPage + ".pt-page-current .intro-text").addClass("load-animate-1");
      $(nextPage + ".pt-page-current .intro-container").addClass("load-animate-2");
    }, 1000);
  }
}
